import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActivity = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Primary",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		id: "Path_550",
		"data-name": "Path 550",
		d: "M950.928,111.684a3.772,3.772,0,0,1,1-.359c.835-.051,1.677-.035,2.515,0,.362.013.5-.117.6-.451.776-2.612,1.575-5.217,2.36-7.827.1-.332.229-.632.616-.657.448-.028.641.251.679.663q.179,1.937.355,3.872c.141,1.538.281,3.076.5,4.624q.361-1.56.724-3.119c.02-.083.039-.166.055-.249.071-.355.193-.67.628-.686.4-.015.555.258.674.585.3.815.612,1.626.918,2.439.331.877.33.878,1.274.879a3.136,3.136,0,0,0,.665-.01,1.351,1.351,0,0,0,.635-.284A1.232,1.232,0,0,1,967,112.7a1.21,1.21,0,0,1-1.7.191,1.176,1.176,0,0,0-.878-.286c-.617.011-1.233,0-1.849,0a.716.716,0,0,1-.768-.538c-.192-.562-.421-1.112-.692-1.819-.094.359-.156.575-.206.795-.348,1.528-.7,3.056-1.035,4.586-.086.387-.232.7-.688.673s-.556-.36-.591-.751q-.381-4.229-.774-8.456a1.217,1.217,0,0,0-.175-.6q-.478,1.577-.958,3.152c-.233.766-.477,1.529-.695,2.3a.715.715,0,0,1-.776.59c-1.165-.008-2.329-.015-3.493,0a.842.842,0,0,1-.794-.448Z",
		transform: "translate(-946.928 -97.383)"
	}), /* @__PURE__ */ _jsx("rect", {
		id: "Rectangle_802",
		"data-name": "Rectangle 802",
		width: 24,
		height: 24,
		fill: "rgba(255,255,255,0)"
	})]
});
export default SvgActivity;
